import { IReaderView, IReaderViewAnnotationLayer } from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-base";
import { ILocator } from "@colibrio/colibrio-reader-framework/colibrio-core-locator";
import { HighlightingTypes } from "../pdf-utils/enums";

export class EpubReadingHighlighter {
    private readerView: IReaderView;
    private annotationLayer: IReaderViewAnnotationLayer;
    private currentWordColor: string;
    private readingUnitColor: string;

    constructor(readerView: IReaderView) {
        this.readerView = readerView;
        this.annotationLayer = this.readerView.createAnnotationLayer('reading-highlights');
        this.annotationLayer.setLayerOptions({
            layerStyle: { 'mix-blend-mode': 'multiply' }
        });
    }

    settingsChanged(currentWordColor: string, readingUnitColor: string) {
        this.currentWordColor = currentWordColor;
        this.readingUnitColor = readingUnitColor;
    }

    createHighlight(location: ILocator, type: HighlightingTypes) {
        // if there is a previous one, destroy it first
        this.destroyHighlight(type);
        // create a new one
        const highlight = this.annotationLayer.createAnnotation(location, { type: type });
        const colour = type === HighlightingTypes.Word ? this.currentWordColor : this.readingUnitColor;
        highlight.setOptions({
            rangeStyle: {
                'background-color': colour,
            }
        });

    }

    destroyHighlight(type: HighlightingTypes) {
        const highlight = this.annotationLayer.getAnnotations().find(h => h.getCustomData().type === type);
        if (!highlight) {
            return;
        }
        this.annotationLayer.destroyAnnotation(highlight)
    }

    destroyAllHighlights() {
        this.annotationLayer.destroyAllAnnotations();
    }
}